import UserLogin from './Settings/SystemUsers/UserLogin'
import UserList from './Settings/SystemUsers/UserList'
import UserDetail from './Settings/SystemUsers/UserDetail'
import UserRegister from './Settings/SystemUsers/UserRegister'
import UserGroups from './Settings/SystemUsers/UserGroups'
import UserRoles from './Settings/SystemUsers/UserRoles'

export default {
    namespaced: true,
    modules: {
        UserLogin: UserLogin,
        UserList: UserList,
        UserDetail: UserDetail,
        UserRegister: UserRegister,
        UserGroups: UserGroups,
        UserRoles: UserRoles
    }
}